import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Deploy from "components/Business/Deploy/Deploy";

import * as projectReducer from "containers/Project/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as deployReducer from "containers/Deployments/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

class DeployContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getIsActiveOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.activeSegment &&
      optimized.activeSegment.conditions.length === 0 &&
      optimized.activeSegment.job &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  render() {
    const {
      match,
      aibleViewType,
      isTableauMode,
      project,
      optimized,
      optimizer,
      segmentOptions,
      modelGroups,
      updateDrilldownValue
    } = this.props;

    return optimized === undefined ? (
      <div
        style={{
          background: "white",
          paddingTop: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <LoadingIndicator style={{ margin: "0px" }} />
      </div>
    ) : (
      <Deploy {...this.props} />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  return {
    init: (aibleViewType) => dispatch(projectReducer.init(id, aibleViewType)),
    updateDrilldownValue: (runId, value) => dispatch(projectReducer.updateDrilldownValue(id, runId, value)),
    setMinBudget: (runId, budget) => dispatch(projectReducer.setSegmentMinBudgetByRunId(id, runId, budget)),
    setMaxBudget: (runId, budget) => dispatch(projectReducer.setSegmentMaxBudgetByRunId(id, runId, budget)),

    updateTruePositive: (runId, val) => {
      dispatch(setupReducer.updateTruePositive(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateFalsePositive: (runId, val) => {
      dispatch(setupReducer.updateFalsePositive(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateTrueNegative: (runId, val) => {
      dispatch(setupReducer.updateTrueNegative(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateFalseNegative: (runId, val) => {
      dispatch(setupReducer.updateFalseNegative(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionGain: (runId, val) => {
      dispatch(setupReducer.updateConversionGain(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionCost: (runId, val) => {
      dispatch(setupReducer.updateConversionCost(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionMissed: (runId, val) => {
      dispatch(setupReducer.updateConversionMissed(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionSaved: (runId, val) => {
      dispatch(setupReducer.updateConversionSaved(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },

    updateExpectedCountContinuous: (runId, val) => dispatch(setupReducer.updateExpectedCountContinuous(runId, val)),
    updateExpectedValueContinuous: (runId, val) => dispatch(setupReducer.updateExpectedValueContinuous(runId, val)),

    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    },

    updateOutcomePercentage: (runId, percentage) => {
      dispatch(projectReducer.updateOutcomePercentage(id, runId, percentage));
    },

    addUserRoleToSegment: (segmentId, userId, role) =>
      dispatch(projectReducer.addUserRoleToSegment(id, segmentId, userId, role)),
    deleteUserRoleFromSegment: (segmentRoleId) => dispatch(projectReducer.deleteUserRoleFromSegment(id, segmentRoleId)),
    deleteUserFromProject: (userId) => dispatch(projectReducer.deleteUserFromProject(id, userId)),
    patchUserRoleSegment: (segmentRoleId, role) =>
      dispatch(projectReducer.patchUserRoleSegment(id, segmentRoleId, role)),

    approveAssumption: (assumptionId) => dispatch(projectReducer.approveAssumption(id, assumptionId)),
    restoreAssumption: (assumptionId) => dispatch(projectReducer.restoreAssumption(id, assumptionId)),
    deleteAssumption: (assumptionId) => dispatch(projectReducer.deleteAssumption(id, assumptionId)),
    viewAssumption: (assumption) => dispatch(projectReducer.viewAssumption(id, assumption)),

    createSplits: (splitOne, splitTwo) => dispatch(projectReducer.createSplits(id, splitOne, splitTwo)),

    rerunSegment: (segmentId) => dispatch(projectReducer.rerunSegment(id, segmentId)),

    updateIsBusinessMode: (isBusiness) => dispatch(globalReducer.updateIsBusinessMode(isBusiness)),

    updateAibleViewType: (view) => dispatch(projectReducer.setAibleViewType(id, view)),

    updateIsBusinessReality: (runId, value) => dispatch(runReducer.updateIsBusinessReality(runId, value)),

    updateCompareScenarioIndex: (index) => dispatch(projectReducer.updateCompareScenarioIndex(id, index)),

    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(id, scenario, index)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(id)),
    saveScenario: (name) => dispatch(projectReducer.saveScenario(id, name)),
    shortlistScenario: () => dispatch(projectReducer.shortlistScenario(id)),
    removeShortlist: () => dispatch(projectReducer.removeShortlist(id)),

    resetBudget: () => dispatch(projectReducer.resetBudget(id)),

    updateScaledTotal: (runId, s) => dispatch(setupReducer.updateScaledTotal(id, runId, s)),

    updateInnerId: (innerId) => dispatch(projectReducer.updateInnerId(id, innerId)),

    deploy: () => dispatch(projectReducer.deploy(id)),

    refresh: () => dispatch(projectReducer.refresh(id)),

    updateModelFeedback: (runId, modelId, isLiked) =>
      dispatch(projectReducer.updateModelFeedback(runId, modelId, isLiked)),

    updateTerminalConditions: (terminalConditions) =>
      dispatch(projectReducer.updateTerminalConditions(id, terminalConditions)),
    updateActivityConditions: (activityConditions) =>
      dispatch(projectReducer.updateActivityConditions(id, activityConditions)),
    updateUniqueId: (uniqueId) => dispatch(projectReducer.updateUniqueIdName(id, uniqueId)),
    updateBusinessPredictionName: (businessPredictionName) =>
      dispatch(projectReducer.updateBusinessPredictionName(id, businessPredictionName)),
    updateFrontierPercentProcessedMin: (runId, frontierPercentProcessedMin) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMin(runId, frontierPercentProcessedMin)),
    updateFrontierPercentProcessedMax: (runId, frontierPercentProcessedMax) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMax(runId, frontierPercentProcessedMax)),
    setFrontierPercentProcessed: (value, useDefault) =>
      dispatch(setupReducer.setFrontierPercentProcessed(id, value, useDefault)),
    updateShowShortListed: (val) => dispatch(projectReducer.updateShowShortListed(id, val)),
    updateShowPending: (val) => dispatch(projectReducer.updateShowPending(id, val)),

    updateProjectMode: (val) => dispatch(projectReducer.updateProjectMode(id, val)),

    updateProjectSetting: (key, val) => dispatch(projectReducer.updateProjectSetting(id, key, val)),

    updateSliderView: (val) => dispatch(projectReducer.updateSliderView(id, val)),

    updateCurrentProjectId: (newId) => dispatch(globalReducer.updateCurrentProjectId(newId)),

    updateMonitorViewMode: (mode) => dispatch(monitoringReducer.updateMonitorViewMode(id, mode)),

    fetchMonitorData: () => dispatch(projectReducer.fetchMonitorData(id)),

    retrainProjectFromDataset: (datasetId) => dispatch(projectReducer.retrainProjectFromDataset(id, datasetId)),

    resetDatasetOutcome: () => dispatch(projectReducer.resetDatasetOutcome(id)),
    goToIntegrate: () =>
      dispatch(businessReducer.updateCurrentStep(ownProps.id, businessReducer.UNIFIED_PROJECT_STEPS.INTEGRATE.id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  const selectedRunId = projectReducer.getRunId(state, id);
  const innerRunId = projectReducer.getInnerId(state, id);

  return {
    errorRuns: projectReducer.getErrorRuns(state, id),
    optimizer: projectReducer.getOptimizer(state, id),
    optimized: projectReducer.getOptimized(state, id),
    modelGroups: projectReducer.getModelGroups(state, id),

    segmentOptions: projectReducer.getSegmentOptions(state, id),

    project: projectReducer.getProject(state, id),

    groupInfo: projectReducer.getGroupInfo(state, id),

    optimalProfit: projectReducer.getOptimalProfit(state, id),
    optimalCost: projectReducer.getOptimalCost(state, id),

    users: adminReducer.getUsers(state),

    runs: viewReducer.getRuns(state),

    continuousFrontier: projectReducer.getContinuousFrontier(state, id),

    aibleViewType: projectReducer.getAibleViewType(state, id),
    aibleViewTypeOptions: projectReducer.getAibleViewTypeOptions(state, id),

    isBusinessMode: globalReducer.getIsBusinessMode(state),
    isTableauMode: globalReducer.getIsTableauMode(state),

    isBusinessReality: runReducer.getIsBusinessReality(state, selectedRunId),

    viewingScenarioIndex: projectReducer.getViewingScenarioIndex(state, id),
    compareScenarioIndex: projectReducer.getCompareScenarioIndex(state, id),

    selectedScenario: projectReducer.getSelectedScenario(state, id),

    allScenarios: projectReducer.getAllScenarios(state, id),

    scaledTotal: setupReducer.getScaledTotal(state, innerRunId),

    userName: loginReducer.getUserName(state),

    selectedDataset: setupReducer.getDatasetFromSetup(state, selectedRunId),
    terminalConditions: projectReducer.getTerminalConditions(state, id),
    activityConditions: projectReducer.getActivityConditions(state, id),
    uniqueId: projectReducer.getUniqueIdName(state, id),
    businessPredictionName: projectReducer.getBusinessPredictionName(state, id),

    showShortListed: projectReducer.getShowShortListed(state, id),
    showPending: projectReducer.getShowPending(state, id),

    projectMode: projectReducer.getProjectMode(state, id),

    sliderView: projectReducer.getSliderView(state, id),
    deployment: deployReducer.getProjectDeployment(state, id),

    monitorViewMode: monitoringReducer.getMonitorViewMode(state, id),

    retrainDataset: projectReducer.getRetrainDataset(state, id),

    isMonitorFeedback: projectReducer.getIsMonitorFeedback(state, id),
    isMonitorRetrain: projectReducer.getIsMonitorRetrain(state, id),
    isAFO: projectReducer.getIsAFO(state, id),
    isSharing: projectReducer.getIsSharing(state, id),
    isLoadingSharing: projectReducer.getIsLoadingSharing(state, id),

    canManageSegmentPermissions: projectReducer.getSegmentManagePermissions(state, id),
    canEditSegments: projectReducer.getSegmentEditPermissions(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DeployContainer);
